import React from "react";

import { ICommandTemplate } from "@formant/core/model/ICommandTemplate";
import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    Input,
    ITypeaheadOption,
    Textarea,
    TypeaheadInput,
} from "@formant/ui-kit";

import { authStore } from "../../../../stores";
import { convertTagsToTypeaheadOptions } from "../utils/convertTagsToTypeaheadOptions";

interface IFormControl<T> {
    control: any;
    getValues: <K extends keyof T>(path?: K) => T[K];
}

interface ICommandTemplateCreateGeneralProps {
    form: IFormControl<ICommandTemplate>;
    existingTagsOptions?: ITypeaheadOption[];
    onTagsChange: (tags: ITypeaheadOption[]) => void;
}

export const CommandTemplateCreateGeneral: React.FC<
    ICommandTemplateCreateGeneralProps
> = ({ form, existingTagsOptions, onTagsChange }) => {
    return (
        <div className="space-y-4">
            <FormField
                control={form.control}
                name="name"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>Name</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                placeholder="Enter command name"
                            />
                        </FormControl>
                    </FormItem>
                )}
            />
            <FormField
                control={form.control}
                name="command"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>Command</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                placeholder="Enter Command name"
                            />
                        </FormControl>
                    </FormItem>
                )}
            />

            <FormField
                control={form.control}
                name="description"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>Description</FormLabel>
                        <FormControl>
                            <Textarea
                                {...field}
                                placeholder="Enter command description"
                            />
                        </FormControl>
                    </FormItem>
                )}
            />
            <TypeaheadInput
                title="Tags"
                description="Tags can be used to limit access to this entity. Tag key and
                value must be alphanumeric with characters a-z, A-Z, 0-9, dash
                (-), and underscore (_)."
                initialOptions={convertTagsToTypeaheadOptions(
                    form.getValues("tags") || {},
                    authStore.userTags,
                )}
                onOptionsChange={onTagsChange}
                availableOptions={existingTagsOptions}
            />
        </div>
    );
};
